/* eslint-disable no-unused-vars */
enum RewardStatus {
  SELECTED = 'Selected',
  ALLOCATED = 'Allocated',
  DISTRIBUTED = 'Distributed',
}

enum Status {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

enum QualifiedStatus {
  YES = 1,
  NO = 0,
}

export { RewardStatus, Status, QualifiedStatus };
